<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                  <h3 class="card-title">Daftar Ruang</h3>
            </div>  
        </div>

        <div class="row">
          <div class="col-12">
            <div class="card" v-if="$gate.isAdmin2()">
              <div class="card-header">
                <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Tambah Ruang
                </button>
                <div class="card-tools">
                    <input type="text" v-model="searchTerm"  placeholder="Cari">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <!--th>ID</th-->
                      <th>Nama Ruang</th>
                      <th>Unit Kerja</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="ruang in ruangs.data" :key="ruang.id">

                      <!--td>{{ruang.id}}</td-->
                      <td class="text-capitalize">{{ruang.nama}}</td>
                      <td>{{ruang.nama_unit_kerja}}</td>
                      <td>

                        <a href="#" @click="editModal(ruang)">
                            <i class="fa fa-edit blue"></i>
                        </a>
						<a href="#" @click="deleteData(ruang.id)">
                            <i class="fa fa-trash red"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="ruangs" @pagination-change-page="getResults"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <div v-if="!$gate.isAdmin2()">
            <not-found></not-found>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Tambah Ruang</h5>
                    <h5 class="modal-title" v-show="editmode">Ubah Ruang</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateRuang() : createRuang()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Nama Ruang</label>
                            <input v-model="form.nama" type="text" name="nama"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('nama') }">
                            <has-error :form="form" field="nama"></has-error>
                        </div>
                        <div class="form-group" v-if="$gate.isAdmin1()">
                            <label>Unit Kerja</label>
                            <select v-model="form.unit_kerja_id" name="unit_kerja_id" class="form-control" :class="{ 'is-invalid': form.errors.has('Unit Kerja') }">
                             <option selected value="">Pilih salah satu</option>

                            <option v-for="unitkerja in unitkerjas" :value="unitkerja.id">
                                {{ unitkerja.nama }}
                            </option>

                            </select>
                            <has-error :form="form" field="unit_kerja_id"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Simpan</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                editmode: false,
                searchTerm:'',
                ruangs : {},
                unitkerjas : {},
                form: new Form({
                    id : '',      
                    nama: '',
                    unit_kerja_id: '',
                })
            }
        },
        methods: {

            getResults(page = 1) {

                  this.$Progress.start();
                  
                  axios.get('/api/ruang?page=' + page).then(({ data }) => (this.ruangs = data.data.ruang));

                  this.$Progress.finish();
            },
            updateRuang(){
                this.$Progress.start();
                this.form.put('/api/ruang/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadRuangs();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },
			deleteData(id){
              Swal.fire({
                  title: 'Apa anda yakin?',
                  text: "Setelah terhapus data tidak bisa dikembalikan!",
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Ya'
                  }).then((result) => {

                      // Send request to the server
                        if (result.value) {
                            this.form.delete('/api/ruang/'+id)
                            .then((response)=>{
                                
                                Toast.fire({
                                        icon: 'success',
                                        title: response.data.message
                                });

                                this.$Progress.finish();

                            })
                            .catch(()=>{
                                Toast.fire({
                                    icon: 'error',
                                    title: 'Some error occured! Please try again'
                                });
                            })

                            window.location.reload();
                        }
                  })
             },
            editModal(ruang){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(ruang);
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },

            loadRuangs(){
                if(this.$gate.isAdmin2()){
                      let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;
                      
                      axios.get("/api/ruang?search="+param).then(({ data }) => (this.ruangs = data.data.ruang, this.unitkerjas = data.data.unit_kerja));
                  }              
            },
            
            createRuang(){

                this.form.post('/api/ruang')
                .then((response)=>{
                    $('#addNew').modal('hide');

                    Toast.fire({
                            icon: 'success',
                            title: response.data.message
                    });

                    this.$Progress.finish();
                    this.loadRuangs();
                })
                .catch(()=>{
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                })
            }

        },
        mounted() {
            console.log('Component mounted.')
        },
        created() {
            this.$Progress.start();
            this.loadRuangs();
            this.$Progress.finish();

        },
        watch: {
            searchTerm: function() {
                this.loadRuangs();
            }
        }
    }
</script>